(() => {
  if (customElements.get('onnais-manual-library')) return;

  const normalize = (value) => value
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\u3400-\u9fff]+/g, ' ')
    .trim();

  class OnnaisManualLibrary extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.category = 'all';
      this.input = this.querySelector('[data-manual-search]');
      this.cards = [...this.querySelectorAll('[data-manual-card]')];
      this.groups = [...this.querySelectorAll('[data-manual-group]')];
      this.buttons = [...this.querySelectorAll('[data-manual-category]')];
      this.searchText = new Map(this.cards.map((card) => [card, normalize(card.dataset.search)]));

      this.querySelector('[data-manual-tools]').hidden = false;
      this.input.addEventListener('input', () => this.filter(), { signal });
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.input.value) {
          event.preventDefault();
          this.clearSearch();
        }
      }, { signal });
      this.querySelector('[data-manual-clear]').addEventListener('click', () => this.clearSearch(), { signal });
      this.querySelector('[data-manual-reset]').addEventListener('click', () => {
        this.category = 'all';
        this.clearSearch();
      }, { signal });
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          this.category = button.dataset.manualCategory;
          this.filter();
        }, { signal });
      });
      // Block selection must reveal a product hidden by the visitor's filters.
      this.addEventListener('shopify:block:select', (event) => {
        if (event.target.closest('[data-manual-card]')) {
          this.category = 'all';
          this.input.value = '';
          this.filter();
        }
      }, { signal });
      this.querySelectorAll('.om__media img').forEach((image) => {
        const showFallback = () => { image.hidden = true; };
        image.addEventListener('error', showFallback, { signal });
        if (image.complete && image.naturalWidth === 0) showFallback();
      });
      this.filter();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    clearSearch() {
      this.input.value = '';
      this.filter();
      this.input.focus();
    }

    filter() {
      const terms = normalize(this.input.value).split(' ').filter(Boolean);
      const counts = { all: 0, rv: 0, safe: 0, lock: 0, eyewear: 0 };
      let visibleCount = 0;
      this.cards.forEach((card) => {
        const matchesQuery = terms.every((term) => this.searchText.get(card).includes(term));
        const matchesCategory = this.category === 'all' || card.dataset.category === this.category;
        if (matchesQuery) {
          counts.all += 1;
          counts[card.dataset.category] += 1;
        }
        card.hidden = !(matchesQuery && matchesCategory);
        if (!card.hidden) visibleCount += 1;
      });
      this.groups.forEach((group) => {
        const count = [...group.querySelectorAll('[data-manual-card]')].filter((card) => !card.hidden).length;
        group.hidden = count === 0;
        group.querySelector('[data-group-count]').textContent = this.productCount(count);
      });
      this.buttons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.manualCategory === this.category));
      });
      this.querySelectorAll('[data-category-count]').forEach((counter) => {
        counter.textContent = counts[counter.dataset.categoryCount];
      });
      this.querySelector('[data-manual-status]').textContent =
        terms.length || this.category !== 'all'
          ? `${this.productCount(visibleCount)} found`
          : this.productCount(visibleCount);
      this.querySelector('[data-manual-clear]').hidden = this.input.value.length === 0;
      this.querySelector('[data-manual-empty]').hidden = visibleCount !== 0 || this.cards.length === 0;
    }

    productCount(count) {
      return `${count} ${count === 1 ? 'product' : 'products'}`;
    }
  }

  customElements.define('onnais-manual-library', OnnaisManualLibrary);
})();
